// app/ai-use-cases/use-case-utils.ts
import { FilterState, UseCase } from "@/app/types/use-case-list";

// Filter use cases based on active filters and search query
export function filterUseCases(
  useCases: UseCase[],
  activeFilters: FilterState,
  searchQuery: string
): UseCase[] {
  if (
    !searchQuery &&
    !activeFilters.industries.length &&
    !activeFilters.models.length &&
    !activeFilters.useCaseTypes.length
  ) {
    return useCases;
  }

  return useCases.filter((useCase) => {
    // Search query filter
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      const matchesTitle = useCase.title.toLowerCase().includes(query);
      const matchesDescription = useCase.description.toLowerCase().includes(query);
      const matchesCategories = useCase.categories.some((cat) =>
        cat.toLowerCase().includes(query)
      );
      const matchesModels = useCase.models.some((model) =>
        model.toLowerCase().includes(query)
      );

      if (!(matchesTitle || matchesDescription || matchesCategories || matchesModels)) {
        return false;
      }
    }

    // Industry filter
    if (
      activeFilters.industries.length &&
      !useCase.categories.some((category) =>
        activeFilters.industries.includes(category)
      )
    ) {
      return false;
    }

    // Model filter
    if (
      activeFilters.models.length &&
      !useCase.models.some((model) => activeFilters.models.includes(model))
    ) {
      return false;
    }

    // Use case type filter (would need implementation if we had types in the data)
    if (activeFilters.useCaseTypes.length) {
      // For now, we don't have use case types in the example data
      // This would need to be implemented based on your data structure
    }

    return true;
  });
} 